<template>
  <div>
    <div class="fixed">
      <transition name="">
        <div class="alert alert-danger" role="alert" v-if="deleteSuccess">
          <span style="font-style: italic; font-weight: bold">{{ modalProps['modalName'] }}</span> deleted successfully!
        </div>
      </transition>
    </div>
    <div class="category-form" ref="userView">
      <CCard class="">
        <CCardHeader align="center">
          <strong>User List</strong>
        </CCardHeader>

        <AdvancedTables
            :key="tableKey"
            @delete="setID"
            @toggle="setToggle"
            :table-headers="[
              'name',
              'email',
              'company',
              'created_at',
              ]"
            :json-data="users"
            :from-component="componentName"
        >
          <div>
            <CModal
                title="Are you sure?"
                color="danger"
                :show.sync="modalProps['showModal']"
            >
              You are about to delete
              <span style="font-weight: bold; font-style: italic">{{ modalProps['modalName'] }}.</span>
              Are you sure?

              <template v-slot:footer>
                <CButton type="button" class="btn btn-secondary" @click="modalProps['showModal'] = false">
                  Cancel
                </CButton>
                <CButton type="button" class="btn btn-danger" @click="deleteUser">
                  Delete
                </CButton>
              </template>
            </CModal>
          </div>
        </AdvancedTables>

      </CCard>
    </div>
  </div>
</template>

<script>
import AdvancedTables from '../table/AdvancedTables';
import axios from "axios";

export default {
  name: "User",
  components: {
    AdvancedTables
  },
  data() {
    return {
      componentName: 'User',
      users: [],
      tempComp: {},
      deleteSuccess: false,
      modal: false,
      modalProps: {
        showModal: false,
        modalName: "",
      },
      deleting: false,
      tableKey: 0,
      toggle: false,
      selected: "",
      result: [],
      newItem: true,
      companyDescription: ""
    }
  },
  mounted() {
    document.title = 'Starter Grower | Users'
    this.populate();
  },
  methods: {
    setID(value) {
      let self = this
      self.selected = value[0]
      self.modalProps['showModal'] = true
      self.modalProps['modalName'] = value[1]
    },
    setToggle(value) {
      let self = this
      self.toggle = value
      self.result = []
    },
    populate() {
      let self = this;
      const token = localStorage.getItem("api_token")
      axios.get(this.$apiAdress + '/api/users', {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log(response.data.data)
        self.tempComp = {}
        self.users = []
        for (let i = 0; i < response.data.data.length; i++) {
          if (response.data.data[i].company != null) {
            self.tempComp['id'] = response.data.data[i].user.id
            self.tempComp['name'] = response.data.data[i].user.name
            self.tempComp['email'] = response.data.data[i].user.email
            self.tempComp['created_at'] = response.data.data[i].user.created_at
            self.tempComp['company_id'] = response.data.data[i].company.id
            self.tempComp['company'] = response.data.data[i].company.name
            self.users.push(self.tempComp)
            self.tempComp = {}
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteUser() {
      let self = this
      const token = localStorage.getItem("api_token")
      axios.delete(this.$apiAdress + '/api/users/' + self.selected, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(function (response) {
        console.log(response.data)
      }).catch(function (error) {
        console.log(error)
      });

      this.deleteSuccess = true;

      setTimeout(function () {
        this.deleteSuccess = !this.deleteSuccess
      }.bind(this), 5000);
      this.forceRerender()
      self.modalProps['showModal'] = false;
    },

    forceRerender() {
      console.log(this.tableKey + "====")
      this.tableKey += 1;
      console.log(this.tableKey + "====")
      this.populate()
    }
  }
}
</script>

<style scoped>

.container {
  grid-template-columns: 20% auto 10% 10%;
  grid-template-rows: 100%
}

.update-btn {
  margin-left: -30%;
}

</style>
